import firebase from 'firebase/app';
import 'firebase/firestore';
import { environment } from '../environments/environment';

const firebaseConfig = environment.firebase;

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const db = firebase.firestore();
